var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tp3uf3ekha)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.039 2.424a.963.963 0 0 1 0 1.362l-3.22 3.22 3.84 3.838 3.219-3.22a.963.963 0 0 1 1.362 1.363l-3.22 3.22 1.92 1.919a.963.963 0 0 1 0 1.362l-2.231 2.23 1.858 1.856a.963.963 0 0 1-1.288 1.429.986.986 0 0 0-.067-.074L3.215 5.959a.977.977 0 0 0-.073-.065.963.963 0 0 1 1.428-1.29l1.364 1.362 2.241-2.242a.963.963 0 0 1 1.363 0l1.92 1.92 3.219-3.22a.963.963 0 0 1 1.362 0zM3.47 8.937c-1.528 2.872-1.257 6.466.813 9.081l-1.31 1.309a.963.963 0 0 0 1.363 1.362l1.309-1.309c2.62 2.073 6.22 2.341 9.094.805l-1.446-1.444c-2.325.975-5.123.52-7.007-1.365-1.881-1.881-2.338-4.672-1.37-6.995L3.471 8.937zm7.297-1.258L8.857 5.767l-1.56 1.56 9.048 9.03 1.551-1.55-1.911-1.912-.008-.007-.008-.008-5.185-5.185-.008-.008-.008-.008z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tp3uf3ekha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnection);
export default __webpack_public_path__ + "static/media/disconnection.ebd8dde89bbcda47d20672f653e621cc.svg";
export { ForwardRef as ReactComponent };